import type {
  QueryFunctionContext,
  UseQueryResult,
} from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';
import groq from 'groq';
import {
  CAMPAIGN_BLOCKS,
  PROMO_CODE,
  PROMO_HERO_V2,
  SEO,
  SLUG,
} from 'lib/queries';
import { client } from 'lib/sanity';
import type { PromotionPageV2 } from 'types/cms/pages/PromotionPageV2';

type PromotionPageV2Query = UseQueryResult & {
  data: PromotionPageV2;
};

export const PROMOTION_V2_PAGE_KEY = 'promotionV2Page';

type PromotionPageV2QueryKey = [string, string];

export const fetchPromotionV2 = async ({
  queryKey,
}: QueryFunctionContext<PromotionPageV2QueryKey>) => {
  const query = groq`
  *[ _type == 'timeline_promotionV2' && slug.current == $slug][0] {
    ${SLUG},
    ${SEO},
    title,
    ${PROMO_CODE},
    ${PROMO_HERO_V2},
    product->{
      "slug": slug.current,
      title,
      frontrowMDProductId
    },
    "blocks": coalesce(template -> blocks[] { ${CAMPAIGN_BLOCKS} }, blocks[]{ ${CAMPAIGN_BLOCKS} })
  }
  `;

  const promotion: PromotionPageV2 = await client.fetch(query, {
    slug: queryKey[1],
  });

  return promotion;
};

export const usePromotionV2 = (slug: string) =>
  useQuery({
    queryKey: [PROMOTION_V2_PAGE_KEY, slug],
    queryFn: fetchPromotionV2,
  }) as PromotionPageV2Query;
